<template>
  <footer class="footer">
    <div class="footer__container container">
      <div class="footer__inner">
        <div class="footer__copy">
          <span>&#169; {{ year }}, IMAST</span>
        </div>
        <div class="footer__links">
          <a href="https://imast.am/terms/" target="_blank">
            {{ $t('footer.terms') }}
          </a>
          <a href="https://imast.am/privacy/" target="_blank">
            {{ $t('footer.policy') }}
          </a>
        </div>
      </div>
    </div>
  </footer>
</template>

<script setup>
const { $t } = useI18n();

const year = ref(0);

onMounted(() => {
  year.value = new Date().getFullYear();
});
</script>

<style lang="scss">
@use '@styles/components/layout/footer.scss' as *;
</style>
